import React, { useState, useCallback } from 'react'
import { Dialog, TextInputField,  toaster } from 'evergreen-ui'
import { connect } from 'react-redux'
import { setLoading, unsetLoading } from '../../Redux/reducers/loading'
import axios from '../../Utils/axios'
import { handleLogin } from '../../Redux/reducers/auth'
import BtnDefault from '../../Components/BtnDefault';
const Register = ({ goBack, visible, dispatch }) => {
  const initialState = {
    email: '',
    name: '',
    password: '',
    confirmPassword: ''
  }
  const [user, setUser] = useState(initialState)
  const [errors, setErrors] = useState({})

  const reset = useCallback(() => {
    setUser(initialState)
    setErrors({})
  }, [initialState])

  const validate = (e) => {
    e.preventDefault();
    const { password, confirmPassword, email, name } = user
    let error = {}
    const emailRegex = /\S+@\S+\.\S+/

    if (!emailRegex.test(email)) {
      let message = 'É ncessário que seja um e-mail válido'
      error = {
        ...error,
        email: message
      }
    }

    if (!name) {
      let message = 'Nome é um campo obrigatório!'
      error = {
        ...error,
        name: message,
      }
    }

    if (password.length < 8) {
      let message = 'É necessário que a senha possua ao menos 8 caracteres!'
      error = {
        ...error,
        password: message,
      }
    }

    if (password !== confirmPassword) {
      let message = 'Senha e confirmação não conferem'
      error = {
        ...error,
        password: message,
        confirmPassword: message
      }
    }
    setErrors(error)
    if (!Object.keys(error).length) register()
  }

  const register = async () => {
    toaster.closeAll()
    try {
      dispatch(setLoading())
      const { data } = await axios.post('/accounts/signup', user)

      toaster.success('Nova conta criada')
      dispatch(handleLogin(data))
    }
    catch (error) {
      const { internalCode, message } = error.response.data.error

      if (internalCode === 5808) {
        toaster.danger('E-mail já cadastrado')
      }
      else {
        toaster.danger(message)
      }

    }
    finally {
      dispatch(unsetLoading())
    }
  }

  const inputs = [
    {
      label: 'E-mail',
      type: 'text',
      required: true, description: 'Deve ser um e-mail válido', name: 'email'
    },
    {
      label: 'Nome', required: true, description: '', name: 'name', type: 'text',
    },
    {
      label: 'Senha', required: true, description: 'Deve possuir ao menos 8 caracteres', name: 'password', type: 'password',
    },
    {
      label: 'Confirmar Senha', required: true, description: '', name: 'confirmPassword', type: 'password',
    },
  ]

  const handleChange = ({ target }) => setUser({
    ...user,
    [target.name]: target.value
  })

  const { email, password, confirmPassword } = user

  return (
    <Dialog
      shouldCloseOnOverlayClick={false}
      isShown={visible}
      title="Cadastre-se"
      onCloseComplete={() => {
        reset()
        goBack()
      }}
      hasFooter={false}
      width={700}
      height={700}
    >
      <form onSubmit={validate}>
        {inputs.map(input => (
          <TextInputField
            key={input.name}
            {...input}
            label={input.label}
            required={input.required}
            description={input.description}
            name={input.name}
            placeholder={input.label}
            isInvalid={!!errors[input.name]}
            validationMessage={errors[input.name] ? errors[input.name] : null}
            value={user[input.name]}
            onChange={handleChange} />
        ))}
        <BtnDefault
          icon='new-person'
          height={40}
          appearance="primary"
          type='submit'
          disabled={!email || !password || !confirmPassword}
          onClick={validate}> Cadastrar </BtnDefault>

      </form>
    </Dialog>

  )
}

export default connect()(Register)
